export default "__VITE_ASSET__D5Za_0Ey__"